import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { FC, useMemo } from "react";
import { useRecoilValue } from "recoil";

import { CoursesDragContextWrapper } from "@ryde/controls";
import {
  courseDraggingStationsTempIdsAtom,
  ICourseDto,
  unique,
} from "@ryde/shared";

import { CourseAddStation } from "./add";
import {
  CourseStationsPanelStyled,
  StationDragOverlayCourse,
  StationsPanelHeaderCourse,
  StationWrapperCourse,
} from "./parts";

interface ICourseStationsPanel {
  courseDto: ICourseDto;
}

export const CourseStationsPanel: FC<ICourseStationsPanel> = ({
  courseDto,
}) => {
  const dragStationIds = useRecoilValue(courseDraggingStationsTempIdsAtom);

  const sortableIds = useMemo(() => {
    const sortableIdsComputed =
      dragStationIds ||
      courseDto.metadata?.stationsInfo?.map(station => station.id) ||
      courseDto.metadata?.stationIds ||
      [];
    return unique(sortableIdsComputed.filter(x => x));
  }, [
    dragStationIds,
    courseDto.metadata?.stationIds,
    courseDto.metadata?.stationsInfo,
  ]);
  return (
    <CoursesDragContextWrapper>
      {!!courseDto && (
        <CourseStationsPanelStyled>
          <StationsPanelHeaderCourse />
          {!!sortableIds.length && (
            <SortableContext
              items={sortableIds}
              strategy={verticalListSortingStrategy}
            >
              {sortableIds.map((stationId, index) => {
                return (
                  <StationWrapperCourse
                    key={stationId}
                    stationId={stationId}
                    courseDto={courseDto}
                    isFirstStation={index === 0}
                    isLastStation={index === sortableIds.length - 1}
                    stationIndex={index}
                  />
                );
              })}
            </SortableContext>
          )}

          <StationDragOverlayCourse />
          <CourseAddStation courseDto={courseDto} />
        </CourseStationsPanelStyled>
      )}
    </CoursesDragContextWrapper>
  );
};
